import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { FirestoreSorter } from "@/core/modules/firestore/objects/FirestoreSorter";
import { Parcel } from "@/features/modules/parcel/objects/Parcel";
import { parcelModel } from "../ParcelModel";

export const getAvailableParcelsByInboundCompanyAndItemCode = async (companyId: string, itemCode: string): Promise<Parcel[]> => {
  try {
    const snapshotQuery: Query<Parcel> = query(
      parcelModel.getPathReference().withConverter(parcelModel.firestoreConverter),
      where("inboundShipment.company.id", "==", companyId),
      where("outboundShipment", "==", null),
      where("itemsCodes", "array-contains", itemCode),
      where("state", "in", ["loosened", "stored"])
    );

    const snapshot: QuerySnapshot<Parcel> = await getDocs(parcelModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return sortDocuments(snapshot.docs.map((doc) => doc.data()));
  } catch (error: unknown) {
    appFaultModel.catchAppError("ParcelModel.getAvailableParcelsByInboundCompanyAndItemCode", { companyId, itemCode }, error);
    return [];
  }
};

function sortDocuments(documents: Parcel[]): Parcel[] {
  const sorter: FirestoreSorter<Parcel> = new FirestoreSorter(documents);
  sorter.addSortCriteria("inboundShipment.date", "asc", "date");
  sorter.addSortCriteria("code", "asc", "string");
  return sorter.sort();
}
